import React from 'react';
import {summaryCounter} from '../../functions/functions';

const SummaryRow = ({columnsList, formData, gridWidths, topLevelFormData, setTopLevelFormData}) => {

    let currentGridWidth = -2;
    let currentGridWidthUpdatePrice = -2;

    return (
        <>
            <tr className="summary">
                {columnsList.filter(e => !e.hidden).map(
                    (col, i) => {

                        const {
                            key,
                            sticky,
                            hideFooterCount,
                        } = col;

                        const style = {
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'sticky',
                            bottom: '0',
                            background: 'white',
                            fontSize: '12px',
                            zIndex: 100,
                        };

                        if (i == 2) {
                            style['gridColumn'] = 'span 2';
                        } else if (i == 3) {
                            return null;
                        }

                        if (sticky) {
                            style['left'] = currentGridWidthUpdatePrice + 'px';
                            currentGridWidthUpdatePrice = parseInt(gridWidths[i]) + currentGridWidthUpdatePrice;
                        }

                        return (
                            <td
                                key={key + i}
                                style={style}
                                className={`${
                                    sticky ? 'isSticky footerSticky' : ''
                                } `}
                            >
                                {i == 2 ? <span style={{padding: '5px'}}>Preise & Zuschläge aktualisieren</span> : null}

                                {col.property.startsWith('order_item_') ? <>

                                    <input
                                        type={"checkbox"}
                                        checked={topLevelFormData?.[col.property + '_update_price']}
                                        className="form-control"
                                        onChange={(e) => {

                                            setTopLevelFormData({
                                                ...topLevelFormData,
                                                [col.property + '_update_price']: e.currentTarget.checked
                                            });
                                        }}
                                    />

                                </> : null}
                            </td>
                        );
                    }
                )}
            </tr>
            <tr className="summary">
                {columnsList.filter(e => !e.hidden).map(
                    (col, i) => {

                        const {
                            key,
                            sticky,
                            hideFooterCount,
                        } = col;

                        const style = {
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'sticky',
                            bottom: '0',
                            background: 'white',
                            fontSize: '12px',
                            zIndex: 100,
                        };

                        if (sticky) {
                            style['left'] = currentGridWidth + 'px';
                            currentGridWidth = parseInt(gridWidths[i]) + currentGridWidth;
                        }

                        return (
                            <td
                                key={key + i}
                                style={style}
                                className={`${
                                    sticky ? 'isSticky footerSticky' : ''
                                } `}
                            >
                                {!hideFooterCount ? <span dangerouslySetInnerHTML={{
                                    __html: summaryCounter(
                                        formData,
                                        key,
                                        col,
                                    )
                                }}></span> : null}
                            </td>
                        );
                    }
                )}
            </tr>
        </>
    );
};

export default SummaryRow;
